import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import initializeErrorArray from './objects/initialize_error_array';

class ReportParmInputModal extends Component {
  constructor(props) {
    super(props);
    this.state={
      parmProcessComplete: false,
      waitState: false,
      investmentMasterLoaded: false,
      headers: setHeadersForFetch(),
      subProcess: "OtherUpdates",
      environment: Config.dataURL.currentEnv,
    }    
    this.errArray = initializeErrorArray(3);
    this.dataValidSw = true;
    this.investmentMasterData = {};
}

editInput(){
    this.setState({dataValidSw: true});
    this.getFormValues();
    this.editFormFields();
}

getFormValues(){
    this.setState({parmProcessComplete: false});
    if (this.props.parmName === "selectInvestment"){
        this.investType = document.getElementById("investType").value;
        this.shortName = document.getElementById("shortName").value;
        this.monthNbr = document.getElementById("monthNbr").value;
    }
}

editFormFields(){
    this.parmProcessComplete = false;
    this.dataValidSw = true;
    this.errArray = initializeErrorArray(3);
    this.setState({waitState: true});
    this.errorMsg = "";
    this.errArr = [];
    if (this.investType === "none"){
        const errorMsg  = "Must select an investment type from the list of options.";
        this.checkErrorArray(0, errorMsg);
    }
    if (this.shortName !== "" && this.shortName !== ""){
        const errorMsg  = "Must enter the shortname for an investment.";
        this.checkErrorArray(1, errorMsg);
    }
    if (isNaN(+this.monthNbr)){
        const errorMsg  = "Month number must be numeric.";
        this.checkErrorArray(2, errorMsg);
    }else{
        if (+this.monthNbr < 1 || +this.monthNbr > 360){
            const errorMsg = "Month number must be between 1 and 360.";
            this.checkErrorArray(2, errorMsg);
        }
    }
    if (this.dataValidSw === false){
        this.errorMsg  = "Correct errors and re-submit.";
        this.setState({waitState: false});
    }else{
        this.loadInvestmentMaster();
    }
}

 checkErrorArray(msgIndex, errorMsg){
    if (errorMsg  && errorMsg !== ""){
        this.errArray[msgIndex] = {textType: "text-danger", message: errorMsg};
        this.dataValid = false;
    }
 } 

checkIfShortNameFound(){
    if (this.investmentFound === false){
        this.dataValid = false;
        const errorMsg = "Invest Type/Short Name not found.";
        this.checkErrorArray(1, errorMsg);
        this.errorMsg  = "Correct errors and re-submit."
    }else{
        const returnObj = {investmentName: this.investmentMasterData[0].investmentName, 
            investType: this.investType, shortName: this.shortName, monthNbr: this.monthNbr};
        this.props.parmsComplete(returnObj);
    }
}

render() {
    if (this.state.investmentMasterLoaded === true){
         this.checkIfShortNameFound();
    }
                           
return <>
    <Modal className="text-center" show={this.props.openModal}  onHide={() => this.props.onClose()} 
       size="md" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title>Enter Parameters to Display Text</Modal.Title>
        </Modal.Header>
        <Modal.Body>
 
            <div className="text-left">
                  <p>Please complete the fields on this form and then click 
                     'Submit'.</p>
            </div>
            {this.state.waitState ?
                <WaitTimeSpinner/>
            :
                <div>
                    {this.props.parmName === "selectInvestment" ?
                        <span>
                            <div className="mt-2">
                            <label className="font-weight-bold" htmlFor="investType">Type:&nbsp;&nbsp;
                            </label>
                                <select 
                                    className="btn btn-sm btn-outline-secondary dropdown-toggle" id="investType">
                                        <option value="No-Type">no type slctd</option>
                                        <option value="stock">Stocks</option>
                                        <option value="bond">Bonds</option>
                                        <option value="index">Index Funds</option>
                                        <option value="mutualfund">Mutual Bonds</option>
                                </select>
                                <span className="text-danger">
                                        &nbsp;{this.errArray[0].message}</span>
                            </div>
                            <div>
                                <label className="mt-4 font-weight-bold" htmlFor="shortName"> 
                                    Invest Short Name:&nbsp;&nbsp;</label>
                                <input type="text" className="form-control input-med" id="shortName" name="shortName"></input> 
                                <div className="text-danger">
                                    &nbsp;{this.errArray[1].message}</div>
                            </div>
                            <div>
                                <label className="mt-4 font-weight-bold" htmlFor="monthNbr"> 
                                    End Month Number:&nbsp;&nbsp;</label>
                                <input type="text" className="form-control input-sm" id="monthNbr" name="monthNbr"></input> 
                                <div className="text-danger">
                                    &nbsp;{this.errArray[2].message}</div>
                            </div>
                        </span>
                    :
                        null
                    }
                </div>
            }
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
            {this.dataValidSw ?
                <div></div>
                :
                <div className="text-danger">{this.errorMsg }</div>
            }
            <Button variant="primary"  onClick={() => this.editInput()}>
                Submit
            </Button>
        </Modal.Footer>
    </Modal>
    
  </>
  }

componentDidMount(){
    this._isMounted = true;
}

loadInvestmentMaster(){
    const funcName = "investmentMasterList";
    const urlParm = "?queryType=shortName&investType=" + this.investType + "&investShortName=" + this.shortName;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
            {method:'GET', headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.investmentFound = true;
                    this.investmentMasterData = output.body;
                    if (this._isMounted === true){
                        this.setState({investmentMasterLoaded: true});
                        this.setState({waitState: false});
                    }
                }else{
                    if (statusCode === 250){
                        this.investmentFound = false;
                        if (this._isMounted === true){
                            this.setState({investmentMasterLoaded: true});
                        } 
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: urlParm};
                        this.processErrorReturn(errorObj);
                    }
                }
            });
        };
    });
}


}

export default ReportParmInputModal;